import {
  userDataChangeAction,
} from '../../actions/UserData';
import { nextStepAction } from '../../actions/Section';
import Product from './product';
import { travelService } from './travel';
import { householdService } from './household';
import { personalService } from './personal';
import { consentService } from './consent';
import { checkBankAccountDetails } from './common';

class FinaCombinedCall extends Product {

  combinedCusPurchase(values, formValues) {
    return async (dispatch, getState) => {
      dispatch(userDataChangeAction({
        fields: [{
          field: "purchasing",
          value: true,
        }]
      }));
      const { userData } = getState();
      let productList = values;
      let failedPurchaseErrorState = null;
      if (!productList) {
        productList = [];
        if (userData.indboInsurance) {
          productList.push("indbo");
        }
        if (userData.rejseInsurance) {
          productList.push("travel");
        }
        if (userData.personInsurance) {
          productList.push("person");
        }
      }
      let productSuccessMap = productList.reduce((acc, item) => {
        acc[item] = true
        return acc
      },{});
      const serviceParamSOFUS = [
        {
          "field": "Payment_service"
        }
      ];
      for (const item of productList) {
        if (item === "indbo") {
          const serviceParams = [
            {
              "field": "productGroupName",
              "value": "Indbo"
            }
          ];
          const actionOnErrors = [
            {
              "actionName": "houseHoldPurchaseError"
            }
          ]
          const modifiedFormValue = {
            ...formValues,
            "insuranceType": "indbo",
            "terminateExistingInsurance_indbo": (formValues.terminateExternalPartyCode_indbo) ? true : false,
            "terminateExternalPartyCode": formValues.terminateExternalPartyCode_indbo
          }
          dispatch(userDataChangeAction({
            fields: [{
              field: "forProduct",
              value: "household",
            }]
          }));
          try {
            await dispatch(householdService.createCustomerV2(serviceParams, modifiedFormValue, actionOnErrors, "household"));
            await dispatch(householdService.purchase(serviceParams, modifiedFormValue, actionOnErrors));
            productSuccessMap[item] = true;
          } catch(error) {
            failedPurchaseErrorState = error;
            productSuccessMap[item] = false;
          }

        }
        else if (item === "travel") {
          const serviceParams = [
            {
              "field": "productGroupName",
              "value": "Rejse"
            }
          ];
          const actionOnErrors = [
            {
              "actionName": "travelPurchaseError"
            }
          ]
          const modifiedFormValue = {
            ...formValues,
            "insuranceType": "Rejse",
            "terminateExistingInsurance_Rejse": (formValues.terminateExternalPartyCode_Rejse) ? true : false,
            "terminateExternalPartyCode": formValues.terminateExternalPartyCode_Rejse
          }
          dispatch(userDataChangeAction({
            fields: [{
              field: "forProduct",
              value: "travel",
            }]
          }));
          try {
            await dispatch(travelService.createCustomerV2(serviceParams, modifiedFormValue, actionOnErrors, "travel"));
            await dispatch(travelService.purchase(serviceParams, modifiedFormValue, actionOnErrors));
            await dispatch(consentService.updateConsentsService(serviceParamSOFUS, modifiedFormValue));
            productSuccessMap[item] = true;
          } catch(error) {
            failedPurchaseErrorState = error;
            productSuccessMap[item] = false;
          }
        }
        else if (item === "person") {
          const serviceParams = [
            {
              "field": "productGroupName",
              "value": "Person"
            }
          ];
          const actionOnErrors = [
            {
              "actionName": "personalPurchaseError"
            }
          ];
          const modifiedFormValue = {
            ...formValues,
            "insuranceType": "Person",
            "terminateExistingInsurance_Person": (formValues.terminateExternalPartyCode_Person) ? true : false,
            "terminateExternalPartyCode": formValues.terminateExternalPartyCode_Person
          }
          dispatch(userDataChangeAction({
            fields: [{
              field: "forProduct",
              value: "personal",
            }]
          }));
          try {
            await dispatch(personalService.createCustomerV2(serviceParams, modifiedFormValue, actionOnErrors, "personal"));
            await dispatch(personalService.purchase(serviceParams, modifiedFormValue, actionOnErrors));
            await dispatch(consentService.updateConsentsService(serviceParamSOFUS, modifiedFormValue));
            productSuccessMap[item] = true;
          } catch(error) {
            failedPurchaseErrorState = error;
            productSuccessMap[item] = false;
          }
        }
      }
      if(Object.values(productSuccessMap).every(item => item === false)) {
        this.handleError([], failedPurchaseErrorState.errorData[0], getState, dispatch);
      } else {
        // send digital customer to sofus if any purchase success
        const serviceParamSOFUS = [{
            "field": "Digital_Customer"
        }];
        await dispatch(consentService.updateConsentsService(serviceParamSOFUS, formValues));
        dispatch(nextStepAction());
      }
      dispatch(userDataChangeAction({
        fields: [{
          field: "purchasing",
          value: false,
        }]
      }));
    }
  }

  combinedCalls(formValues) {
    return async (dispatch, getState) => {

      dispatch(userDataChangeAction({
        fields: [{
          field: "purchasing",
          value: true,
        }]
      }));

      const userDataBeforeBankValidation = getState().userData;
      //check bank account valid or not
      let proceedForPurchase = "Valid";
      let checkBankAccount = true;
      if(userDataBeforeBankValidation.indboInsurance && 
        !userDataBeforeBankValidation.rejseInsurance && 
        !userDataBeforeBankValidation.personInsurance){
          checkBankAccount = false;
      }

      if(checkBankAccount) {
        try {
          const serviceParam = {
            "nextStep": false
          }
          await dispatch(checkBankAccountDetails(serviceParam, formValues));
        } catch(error) {
          return;
        }
      }

      const { userData } = getState();
      const priceCalls = [];
      const products = [];
      proceedForPurchase = (userData.validAccountNo) ? userData.validAccountNo: proceedForPurchase;

      if(proceedForPurchase === "Valid") {
        if (userData.indboInsurance) {
          dispatch(userDataChangeAction({
            fields: [{
              field: "forProduct",
              value: "household",
            },
            {
              field: "ownerShip",
              value: formValues.ownerShipText,
            }
          ]
          }));
          const params = [
            {
              "field": "productGroupName",
              "value": "Indbo"
            }
          ];
          const actionOnErrors = [
            {
              "actionName": "houseHoldError"
            }
          ];

          priceCalls.push(dispatch(householdService.createUpdateHouseholdAction(params,
            actionOnErrors, formValues)));
          products.push("indbo");
        }
        if (userData.rejseInsurance) {
          dispatch(userDataChangeAction({
            fields: [{
              field: "forProduct",
              value: "travel",
            }]
          }));
          const params = [
            {
              "field": "productGroupName",
              "value": "Rejse"
            }
          ];

          const actionOnErrors = [
            {
              "actionName": "travelError"
            }
          ];
          priceCalls.push(dispatch(travelService.createUpdateTravelAction(params,
            actionOnErrors, formValues)))
          products.push("travel");
        }
        if (userData.personInsurance) {
          dispatch(userDataChangeAction({
            fields: [{
              field: "forProduct",
              value: "personal",
            }]
          }));
          const params = [
            {
              "field": "productGroupName",
              "value": "Person"
            }
          ];
          const actionOnErrors = [
            {
              "actionName": "personError"
            }
          ];
          priceCalls.push(dispatch(personalService.createUpdatePersonalAction(params,
            actionOnErrors, formValues)));
          products.push("person");
        }
        const userDataChangeCall = [];
        userDataChangeCall.push(
          dispatch(userDataChangeAction({
            fields: [{
              "field": "chosenPackage-household",
              "value": "combined0"
            },
            {
              "field": "chosenPackage-travel",
              "value": "combined1"
            },
            {
              "field": "chosenPackage-person",
              "value": "combined2"
            }]
          }))
        );

        if (userData.travelSuper) {
          userDataChangeCall.push(dispatch(userDataChangeAction({
            fields: [
              {
                "field": "chosenPackage-travel",
                "value": "combined3"
              }]
          })));
        }

        //Submit CPR consent
        const serviceParam = [
          {
            "field": "CPR_offer"
          }
        ];
        dispatch(consentService.updateConsentsService(serviceParam, formValues));

        const results = await Promise.allSettled(priceCalls);

        const sucessCall = [];
        const failsCall = [];
        if (results.length > 0) {
          products.forEach((item, index) => {
            if (!results[index].value) {
              sucessCall.push(item);
            } else {
              failsCall.push(item)
            }
          });
        }
        await Promise.all(userDataChangeCall);

        //Save Claim History & Terminate Insurance
        if(formValues.otherCompanyInsured === "yes-start-date-message") {
          const serviceParam = [
            {
              "field": "Claim_History"
            }
          ];
          try {
            await dispatch(consentService.updateConsentsService(serviceParam, formValues));
          } catch(error) {
            throw error;
          }

          if(userData.variableConsents && userData.variableConsents.length !== 0) {
            let serviceParam = [
              {
                "field": "Terminate_Insurance"
              }
            ];
            for(const consent of userData.variableConsents) {
              let modifiedFormValue = {
                ...formValues,
                "Terminate_Insurance": true,
                "terminateExternalPartyCode-label": consent.option.existingInsuranceCompany
              }
              try {
                await dispatch(consentService.updateConsentsService(serviceParam, modifiedFormValue));
              } catch(error) {
                throw error;
              }
            }
          }
        }

        if (sucessCall.length === products.length) {
          dispatch(this.combinedCusPurchase(sucessCall, formValues));
        } else {
          dispatch(userDataChangeAction({
            fields: [{
              field: "purchasing",
              value: false,
            }]
          }));
        }
        if(failsCall.length === products.length) {
          this.handleError([], results[0].value.errorData[0], getState, dispatch);
        }
      }
    }
  }
}

export const finaCombinedCall = new FinaCombinedCall();